"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Member = exports.Stats = exports.PrivacyStatus = exports.MediaPlatformImage = exports.RoleAction = exports.RoleId = exports.ActivityMemberBadge = exports.CustomMemberBadge = exports.MemberBadge = exports.ActivityType = exports.ActivityBadgeLevel = exports.CustomBadge = exports.ActivityBadge = exports.Badge = void 0;
var Badge = /** @class */ (function () {
    function Badge() {
    }
    return Badge;
}());
exports.Badge = Badge;
var ActivityBadge = /** @class */ (function (_super) {
    __extends(ActivityBadge, _super);
    function ActivityBadge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ActivityBadge;
}(Badge));
exports.ActivityBadge = ActivityBadge;
var CustomBadge = /** @class */ (function (_super) {
    __extends(CustomBadge, _super);
    function CustomBadge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CustomBadge;
}(Badge));
exports.CustomBadge = CustomBadge;
var ActivityBadgeLevel = /** @class */ (function () {
    function ActivityBadgeLevel() {
    }
    return ActivityBadgeLevel;
}());
exports.ActivityBadgeLevel = ActivityBadgeLevel;
var ActivityType;
(function (ActivityType) {
    ActivityType[ActivityType["POSTS"] = 0] = "POSTS";
    ActivityType[ActivityType["LIKES"] = 1] = "LIKES";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
var MemberBadge = /** @class */ (function () {
    function MemberBadge() {
    }
    return MemberBadge;
}());
exports.MemberBadge = MemberBadge;
var CustomMemberBadge = /** @class */ (function (_super) {
    __extends(CustomMemberBadge, _super);
    function CustomMemberBadge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CustomMemberBadge;
}(MemberBadge));
exports.CustomMemberBadge = CustomMemberBadge;
var ActivityMemberBadge = /** @class */ (function (_super) {
    __extends(ActivityMemberBadge, _super);
    function ActivityMemberBadge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ActivityMemberBadge;
}(MemberBadge));
exports.ActivityMemberBadge = ActivityMemberBadge;
var RoleId;
(function (RoleId) {
    RoleId["JOIN_COMMUNITY"] = "join_community";
    RoleId["LEAVE_COMMUNITY"] = "leave_community";
    RoleId["EDIT"] = "edit";
    RoleId["ANONYMOUS_REPORT"] = "anonymous_report";
    RoleId["MANAGE_BADGES"] = "manage_badges";
    RoleId["REPORT_MEMBER"] = "report";
    RoleId["BLOCK_MEMBER"] = "blocked";
    RoleId["UNBLOCK_MEMBER"] = "unblocked";
    RoleId["SET_FORUM_MODERATOR"] = "forum_moderator";
    RoleId["UNSET_FORUM_MODERATOR"] = "unset_forum_moderator";
    RoleId["SET_BLOG_WRITER"] = "blog_writer";
    RoleId["UNSET_BLOG_WRITER"] = "unset_blog_writer";
    RoleId["SET_BLOG_GUEST_WRITER"] = "blog_guest_writer";
    RoleId["UNSET_BLOG_GUEST_WRITER"] = "unset_blog_guest_writer";
    RoleId["ADMIN"] = "admin";
    RoleId["SET_BLOG_EDITOR"] = "blog_editor";
    RoleId["UNSET_BLOG_EDITOR"] = "unset_blog_editor";
    RoleId["GUEST"] = "guest";
    RoleId["DELETE_MEMBER"] = "deleted";
    RoleId["CONTACT_PAGE"] = "contact_page";
    RoleId["OPEN_CHAT"] = "open_chat";
    RoleId["FOLLOW_UNFOLLOW"] = "follow_unfollow";
    RoleId["OPEN_BLOG_WRITER"] = "open_blog_writer";
    RoleId["MEMBER_BLOCK_MEMBER"] = "member_block_member";
    RoleId["MEMBER_UNBLOCK_MEMBER"] = "member_unblock_member";
})(RoleId = exports.RoleId || (exports.RoleId = {}));
var RoleAction = /** @class */ (function () {
    function RoleAction() {
    }
    return RoleAction;
}());
exports.RoleAction = RoleAction;
var MediaPlatformImage = /** @class */ (function () {
    function MediaPlatformImage() {
    }
    return MediaPlatformImage;
}());
exports.MediaPlatformImage = MediaPlatformImage;
var PrivacyStatus;
(function (PrivacyStatus) {
    PrivacyStatus["Private"] = "PRIVATE";
    PrivacyStatus["Public"] = "PUBLIC";
    PrivacyStatus["Unknown"] = "UNKNOWN";
})(PrivacyStatus = exports.PrivacyStatus || (exports.PrivacyStatus = {}));
var Stats = /** @class */ (function () {
    function Stats() {
    }
    return Stats;
}());
exports.Stats = Stats;
var Member = /** @class */ (function () {
    function Member() {
    }
    return Member;
}());
exports.Member = Member;
//# sourceMappingURL=index.js.map